import { createElement } from "@wordpress/element";
export default function save(_ref) {
  var attributes = _ref.attributes;
  return createElement("pre", null, createElement("code", null, attributes.content));
}
//# sourceMappingURL=save.js.map